"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderDesktop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _queryString = _interopRequireDefault(require("query-string"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _MenuOpen = _interopRequireDefault(require("@material-ui/icons/MenuOpen"));
var _userUtils = require("./userUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-nested-ternary */

const useStyles = (0, _styles.makeStyles)(theme => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: 'center'
  },
  logo: {
    padding: 0
  },
  searchWrapper: {
    height: 36,
    display: 'flex',
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    width: 931,
    [theme.breakpoints.up(1300)]: {
      marginLeft: -40
    },
    [theme.breakpoints.down(1300)]: {
      width: '60.244%'
    }
  },
  searchIcon: {
    color: 'black',
    verticalAlign: 'middle'
  },
  primaryText: {
    marginTop: 2,
    color: theme.palette.text.primary,
    width: 200
  },
  secondaryText: {
    color: theme.palette.text.secondary,
    fontSize: 14
  },
  avatar: {
    padding: 0
  },
  menu: {
    marginTop: 48
  },
  menuAvatar: {
    marginRight: 16
  },
  menuIcons: {
    marginRight: 24,
    marginLeft: 8,
    [theme.breakpoints.down(1300)]: {
      marginRight: 0
    }
  },
  menuItemText: {
    color: theme.palette.text.primary,
    width: 'auto',
    fontSize: 14
  },
  inputLeftButton: {
    minWidth: 24,
    margin: 8,
    marginLeft: 16
  },
  inputRightButton: {
    width: 24,
    minWidth: 24,
    margin: '0 8px'
  },
  inputBaseRoot: {
    height: 24,
    padding: '6px 0'
  },
  menuStyle: {},
  centralized: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  appBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row'
  },
  sandwichWrapper: {
    margin: '16px 24px 16px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '32px',
    height: '32px',
    '& svg': {
      width: 32,
      height: 32
    }
  },
  toolbarSandwich: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: 'center',
    flex: 1,
    padding: 0,
    paddingRight: 24
  },
  drawer: {
    backgroundColor: 'transparent',
    '& .MuiDrawer-paper': {
      width: 302,
      marginTop: 64,
      display: 'flex',
      alignItems: 'center'
    }
  }
}));
const HeaderDesktop = _ref => {
  let {
    username,
    email,
    onClickHome,
    searchPlaceHolder,
    inputWrapperClasses,
    searchCallback,
    hiddenMenu,
    menuItems,
    logo,
    logoImg,
    centralized,
    sandwich,
    sandwichClosedIcon,
    sandwichOpenedIcon,
    isOpenSandwich,
    setIsOpenSandwich
  } = _ref;
  const classes = useStyles();
  const initials = (0, _userUtils.getInitials)(username);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const open = Boolean(anchorEl);
  const [isTyping, setIsTyping] = (0, _react.useState)(false);
  let searchTerm = '';
  if (window.location.search && window.location.search.includes('?query=')) {
    searchTerm = _queryString.default.parse(window.location.search).query;
  }
  const [inputValue, setInputValue] = (0, _react.useState)(searchTerm);
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function clearSearch() {
    setIsTyping(false);
    setInputValue('');
  }
  function handleSearchChange(evt) {
    setInputValue(evt.target.value);
    if (evt.target.value === '') {
      setIsTyping(false);
      return;
    }
    if (!isTyping) {
      setIsTyping(true);
    }
  }
  function handleSubmit(evt) {
    evt.preventDefault();
    searchCallback(inputValue);
  }
  function renderMenuItem(item) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: item.onClick,
      key: item.label
    }, item.nodeIcon, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.menuItemText
    }, item.label));
  }
  function renderSearchBar() {
    const inputWrapperStyle = inputWrapperClasses ? `${classes.searchWrapper} ${inputWrapperClasses().root}` : centralized ? `${classes.searchWrapper} ${classes.centralized}` : classes.searchWrapper;
    const searchIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.inputLeftButton
    }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, {
      className: classes.searchIcon
    })));
    const closeButton = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: clearSearch,
      className: classes.inputRightButton
    }, /*#__PURE__*/_react.default.createElement(_icons.Close, null)));
    return /*#__PURE__*/_react.default.createElement("form", {
      className: inputWrapperStyle,
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_core.Input, {
      disableUnderline: true,
      placeholder: searchPlaceHolder,
      fullWidth: true,
      onChange: handleSearchChange,
      value: inputValue,
      classes: {
        input: classes.inputBaseRoot
      },
      startAdornment: searchIcon,
      endAdornment: isTyping || inputValue !== '' ? closeButton : null
    }));
  }
  function AvatarLogout() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, menuItems.map(item => renderMenuItem(item)));
  }
  function AvatarLogin() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      className: classes.menuStyle
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.menuAvatar
    }, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText
    }, (0, _userUtils.listUser)(username, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.secondaryText
    }, (0, _userUtils.listUser)(email, 28)))), menuItems.map(item => renderMenuItem(item)));
  }
  function renderMenu() {
    return /*#__PURE__*/_react.default.createElement(_core.Menu, {
      className: classes.menu,
      anchorEl: anchorEl,
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: open,
      onClose: handleClose
    }, initials === null ? /*#__PURE__*/_react.default.createElement(AvatarLogout, null) : /*#__PURE__*/_react.default.createElement(AvatarLogin, null));
  }
  function renderAvatar() {
    if (hiddenMenu) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: 40,
          height: 40
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "Perfil do Usu\xE1rio",
      className: classes.avatar,
      onClick: handleMenu
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), renderMenu());
  }
  const handleClickHome = evt => {
    setInputValue('');
    setIsTyping(false);
    onClickHome(evt);
  };
  const sandwichMenu = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      onClick: () => setIsOpenSandwich(!isOpenSandwich),
      onKeyDown: () => setIsOpenSandwich(!isOpenSandwich),
      className: classes.sandwichWrapper,
      role: "button",
      tabIndex: 0,
      "aria-label": isOpenSandwich ? 'Fechar Menu' : 'Abrir Menu'
    }, isOpenSandwich ? sandwichOpenedIcon : sandwichClosedIcon));
  };
  if (sandwich) {
    return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
      className: classes.appBar
    }, sandwichMenu(), /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
      classes: {
        root: classes.toolbarSandwich
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.logo,
      onClick: handleClickHome
    }, logo && /*#__PURE__*/_react.default.createElement("img", {
      style: {
        maxHeight: 40
      },
      src: logo,
      alt: "logo"
    }), logoImg && logoImg), renderSearchBar(), renderAvatar()));
  }
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, null, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    classes: {
      root: classes.toolbar
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.logo,
    onClick: handleClickHome
  }, logo && /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxHeight: 40
    },
    src: logo,
    alt: "logo"
  }), logoImg && logoImg), renderSearchBar(), renderAvatar()));
};
exports.HeaderDesktop = HeaderDesktop;
HeaderDesktop.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string,
  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,
  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,
  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,
  /**
   * Função requerida para quando a pessoa realizar a pesquisa (apertar o Enter).
   * Receberá como parâmetro o termo que está na barra de pesquisa
   */
  searchCallback: _propTypes.default.func.isRequired,
  /**
   *  Classes para serem aplicadas na `div` que engloba a barra de pesquisa
   */
  inputWrapperClasses: _propTypes.default.func,
  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired,
  hiddenMenu: _propTypes.default.bool,
  /**
   * Logo que aparecerá no topo da página.
   */
  logo: _propTypes.default.element,
  /**
   * Logo que aparecerá no topo da página caso seja passado uma tag de imagem.
   */
  logoImg: _propTypes.default.node,
  /**
   * Se 'TRUE' a search bar fica centralizada ao centro de forma absoluta
   */
  centralized: _propTypes.default.bool,
  /**
   * Se 'TRUE' habilita o menu sanduiche no header
   */
  sandwich: _propTypes.default.bool,
  /**
   * Ícone do menu sanduiche enquanto está fechado
   */
  sandwichClosedIcon: _propTypes.default.node,
  /**
   * Ícone do menu sanduiche enquanto está aberto
   */
  sandwichOpenedIcon: _propTypes.default.node,
  /**
   * Se 'TRUE', o estado do menu sandwich é aberto
   */
  isOpenSandwich: _propTypes.default.bool,
  /**
   * Funcao que manipula o estado do menu sanduiche
   */
  setIsOpenSandwich: _propTypes.default.func
};
HeaderDesktop.defaultProps = {
  email: 'email@somoseducacao.com.br',
  username: 'Saraiva Educacao',
  searchPlaceHolder: 'Buscar...',
  inputWrapperClasses: null,
  hiddenMenu: false,
  centralized: false,
  logo: null,
  logoImg: null,
  sandwich: false,
  sandwichClosedIcon: /*#__PURE__*/_react.default.createElement(_Menu.default, null),
  sandwichOpenedIcon: /*#__PURE__*/_react.default.createElement(_MenuOpen.default, null),
  isOpenSandwich: false,
  setIsOpenSandwich: null
};
var _default = exports.default = HeaderDesktop;